'use strict';

var tslib_es6 = require('../../_virtual/tslib.es6-20bd5fbf.js');
var React = require('react');
var classNames = require('classnames');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

/**
 * A single WDS icon.
 *
 * **NOTE**: This icon is using `IconSprite` component.
 */
const Icon = (_a) => {
    var { name, className, small, tiny } = _a, rest = tslib_es6.__rest(_a, ["name", "className", "small", "tiny"]);
    const isSmall = small || /-small$/.test(name);
    const isTiny = tiny || /-tiny$/.test(name);
    const classes = classNames__default["default"]('wds-icon', className, { 'wds-icon-small': isSmall }, { 'wds-icon-tiny': isTiny });
    return (React__default["default"].createElement("svg", Object.assign({ className: classes }, rest),
        React__default["default"].createElement("use", { xlinkHref: `#wds-icons-${name}` })));
};

module.exports = Icon;
